export default "__VITE_ASSET__wl64PYON__"